import React from 'react';
import OrderExchangeList from '../OrderExchangeList';
import OrderExchangeListSummaryBox from '../OrderExchangeListSummaryBox';
import OrderExchangeListSearchBox from '../OrderExchangeListSearchBox';

const OrderExchangeListWrap = (props) => {
  const { setData, orderExchangeList, mainProductCategorySelectList, getList, getExcelDownload } = props;

  return (
    <div className="order-exchange-list-wrap">
      {/* 주문 교환 서머리 데이터 */}
      <OrderExchangeListSummaryBox orderExchangeSummaryBox={orderExchangeList.orderExchangeSummaryBox} />

      {/*주문 교환 서치 박스*/}
      <OrderExchangeListSearchBox
        setData={(data) =>
          setData({
            path: ['orderExchangeList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={orderExchangeList.searchData}
        getList={getList}
      />

      {/* 주문 교환 리스트 */}
      <OrderExchangeList
        orderExchangeList={orderExchangeList}
        mainProductCategorySelectList={mainProductCategorySelectList}
        getList={getList}
        getExcelDownload={getExcelDownload}
      />
    </div>
  );
};

export default OrderExchangeListWrap;
